export const NEXT_STEP = "components.steppers.NEXT_STEP";
export const BACK_STEP = "components.steppers.BACK_STEP";
export const GO_TO_STEP = "components.steppers.GO_TO_STEP";
export const SET_ACTIVE_STEP = "components.steppers.SET_ACTIVE_STEP";
export const SET_STEPS = "components.steppers.SET_STEPS";
export const SET_INITIAL_RENDER = "components.steppers.INITIAL_RENDER";
